import { EIconShape, EPopupDevices } from '~/features/agents/models'
import { TFormSubmissionFieldForLayout } from '~/features/preChatForms/models'
import { EMessageSpeaker } from '~/models/features'

export enum ESocialLinks {
  facebook = 'facebook.com',
  instagram = 'instagram.com',
  linkedin = 'linkedin.com',
  twitter = 'twitter.com',
  yoututbe = 'youtube.com',
  github = 'github.com',
  pinterest = 'pinterest.com',
  reddit = 'reddit.com',
  snapchart = 'snapchat.com',
  tiktok = 'tiktok.com',
  whatsapp = 'whatsapp.com',
  zoom = 'zoom.com',
}

export type TPreChatFormSubmissionPayload = {
  formSubmissionId?: string
  fields: TFormSubmissionFieldForLayout[]
}

export type TChatTextMessage = {
  speaker: EMessageSpeaker
  message: string
  preChatFormSubmission?: undefined
}

export type TChatPreChatFormSubmissionMessage = {
  speaker: EMessageSpeaker.user
  message?: undefined
  preChatFormSubmission: TPreChatFormSubmissionPayload
}

export type TChatMessage = TChatTextMessage | TChatPreChatFormSubmissionMessage

export enum EEmbeddedChatMessageType {
  minimize = 'minimize',
  close = 'close',
  loadPopup = 'loadPopup',
  loadIconStyles = 'loadIconStyles',
  updateReferrer = 'updateReferrer',
  updateCurrentPage = 'updateCurrentPage',
  remount = 'remount',
}

export type TEmbeddedChatMessageData = {
  height?: number
  isMinimized?: boolean
  autoClosePopupDelay?: number
  customIconUrl?: string
  openPopupDelay?: number
  popupDevices?: EPopupDevices[]
  popupMessage?: string
  iconBackgroundColor?: string
  iconColor?: string
  iconShape?: EIconShape | null
  referrer?: string
  // Path (no query string) of the customer-site page the widget is embedded
  // on — sent once at load by chatbot-embed.js, same as referrer.
  currentPage?: string
}

export type TEmbeddedChatMessage = {
  id: string
  type: EEmbeddedChatMessageType
  data?: TEmbeddedChatMessageData
  timestamp: number
}
